import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AppStore from 'store/AppStore'
import FixedSlideNav from '../../components/navbar/FixedSlideNav'
import { links } from '../../quality/constants/StationsConstants'
import { execByType } from '../../utils/StationUtils'
import i18n from 'simple-react-i18n'
import User from '../../account/dto/User'
import ProductionUnitAction from '../../productionUnit/actions/ProductionUnitAction'
import DistributionUnitAction from '../../distributionUnit/actions/DistributionUnitAction'
import { Outlet } from 'react-router-dom'
import HomeAction from 'home/actions/HomeAction'
import {
    H_PRODUCTION_VOLUMES,
    H_RESOURCE_DASHBOARD,
    H_STATION_RESOURCE_OPTIONS,
    H_UNITS_COUNTERS,
    H_UNITS_DASHBOARD,
    H_UNITS_OPTIONS,
    H_UNITS_CONFORMITY,
} from '../../account/constants/AccessRulesConstants'
import { componentHasHabilitations } from '../../utils/HabilitationUtil'
import BoundaryError from 'log/components/BoundaryError'
import ResourceAction from 'resource/actions/ResourceAction'
import { Box } from '@mui/material'

class StationsApp extends Component {
    constructor(props) {
        super(props)
        this.state = {
            stationType: (() => {
                const type = (window.location.href || document.URL).split('#')[1].split('/')[1]
                if (['resource', 'productionUnit', 'distributionUnit'].indexOf(type) !== -1) {
                    return type
                }
                return 'pluviometry'
            })(),
        }
    }

    fetchStations = (type) => {
        execByType(type, {
            productionUnit: () => {
                AppStore.dispatch(ProductionUnitAction.fetchProductionUnits())
                AppStore.dispatch(HomeAction.setHelpLink('', ''))
            },
            resource: () => {
                AppStore.dispatch(ResourceAction.fetchResources())
                AppStore.dispatch(HomeAction.setHelpLink('', ''))
            },
            distributionUnit: () => {
                AppStore.dispatch(DistributionUnitAction.fetchDistributionUnits())
                AppStore.dispatch(HomeAction.setHelpLink('', ''))
            },
        })
    }

    checkStationType = () => {
        const stationType = location.href.split('/')[4]
        if (stationType !== this.state.stationType && ['resource', 'productionUnit', 'distributionUnit'].find(type => type === stationType)) {
            this.setState({ stationType })
            this.fetchStations(stationType)
        }
    }

    componentDidMount() {
        this.checkStationType()
        this.fetchStations(this.state.stationType)
    }

    getLink = (linkName) => {
        if (linkName.includes('dev')) {
            const linkDev = links[linkName.replace('dev', '')]
            return {
                ...linkDev,
                href: `/${this.state.stationType}/develop`,
                name: i18n[linkDev.i18n],
            }
        }
        const link = links[linkName]
        return {
            ...link,
            href: link.href || `/${this.state.stationType}/${link.hrefName || linkName}`,
            name: i18n[link.i18n],
        }
    }

    render() {
        const navBarLinks = execByType(this.state.stationType, {
            distributionUnit: () => [
                { habilitation: H_UNITS_DASHBOARD, link: 'dashboard' },
                { habilitation: H_UNITS_COUNTERS, link: 'counters' },
                { habilitation: H_UNITS_CONFORMITY, link: 'conformityOverview' },
                { habilitation: H_UNITS_OPTIONS, link: 'distributionUnitOptions' },
            ],
            productionUnit: () => [
                { habilitation: H_UNITS_DASHBOARD, link: 'dashboard' },
                { habilitation: H_PRODUCTION_VOLUMES, link: 'productionUnitVolumes' },
                { habilitation: H_UNITS_OPTIONS, link: 'productionUnitOptions' },
            ],
            resource: () => [
                { habilitation: H_RESOURCE_DASHBOARD, link: 'dashboard' },
                { habilitation: H_STATION_RESOURCE_OPTIONS, link: 'resourceOptions' },
            ],
        })
            .filter(l => componentHasHabilitations(l.habilitation))
            .map(l => this.getLink(l.link))
            .filter(l => !!l)

        return (
            <Box>
                <FixedSlideNav links={navBarLinks} />
                <Box className='content-page fullscreen' padding={1}>
                    <BoundaryError>
                        <Outlet />
                    </BoundaryError>
                </Box>
            </Box>
        )
    }

    componentDidUpdate() {
        this.checkStationType()
    }
}

StationsApp.propTypes = {
    children: PropTypes.element,
    getLink: PropTypes.func,
    popup: PropTypes.element,
    accountUser: PropTypes.instanceOf(User),
}

const mapStateToProps = store => ({
    popup: store.StationReducer.popup,
    accountUser: store.AccountReducer.accountUser,
})

export default connect(mapStateToProps)(StationsApp)
